__turbopack_context__.v({
  "btn-full": "Confirm-module-scss-module__SX31xW__btn-full",
  "cancel-link": "Confirm-module-scss-module__SX31xW__cancel-link",
  "centered": "Confirm-module-scss-module__SX31xW__centered",
  "close-btn": "Confirm-module-scss-module__SX31xW__close-btn",
  "confirm": "Confirm-module-scss-module__SX31xW__confirm",
  "confirm-modal-box": "Confirm-module-scss-module__SX31xW__confirm-modal-box",
  "confirm-modal-box--cart": "Confirm-module-scss-module__SX31xW__confirm-modal-box--cart",
  "confirm-modal-inner": "Confirm-module-scss-module__SX31xW__confirm-modal-inner",
  "confirm-overlay": "Confirm-module-scss-module__SX31xW__confirm-overlay",
  "delete": "Confirm-module-scss-module__SX31xW__delete",
  "description": "Confirm-module-scss-module__SX31xW__description",
  "header-icon": "Confirm-module-scss-module__SX31xW__header-icon",
  "header-icon-svg": "Confirm-module-scss-module__SX31xW__header-icon-svg",
  "header-row": "Confirm-module-scss-module__SX31xW__header-row",
  "modal-content": "Confirm-module-scss-module__SX31xW__modal-content",
  "modal-footer": "Confirm-module-scss-module__SX31xW__modal-footer",
  "modal-header": "Confirm-module-scss-module__SX31xW__modal-header",
  "tertiary": "Confirm-module-scss-module__SX31xW__tertiary",
  "title": "Confirm-module-scss-module__SX31xW__title",
});
